import { Modal, Divider, Col, Row, Statistic, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { getAppChargeUsageApi, getAppChargeRecentAverageUsageApi } from '@/services/addApp';
import { useEffect, useState } from 'react';
import moment from 'moment';

/**
 * 项目小程序
 */
const AppChargeUsageModal = (props: any) => {
  const { chargeVisible, setChargeVisible, appInfo } = props;

  const [chargeUsage, setChargeUsage] = useState<any>({});
  const [chargeRecentAverageUsage, setChargeRecentAverageUsage] = useState<any>({});
  const getAppPhoneVerifyUsage = async (appId: string) => {
    const chargeUsageResp = await getAppChargeUsageApi({ appId: appId });
    setChargeUsage(chargeUsageResp?.data?.details);
    const chargeRecentAverageUsageResp = await getAppChargeRecentAverageUsageApi({ appId: appId });
    setChargeRecentAverageUsage(chargeRecentAverageUsageResp?.data?.details);
  };

  useEffect(() => {
    if (appInfo?.appId) {
      getAppPhoneVerifyUsage(appInfo?.appId);
    }
  }, [appInfo]);

  // ======= 详细资源包使用情况 =======
  interface DataType {
    key: string;
    name: string;
    age: number;
    address: string;
    tags: string[];
  }

  /**
   * 资源包来源的枚举值
   */
  const packageSourceEnum: any = {
    1: '体验额度',
    2: '付费购买',
    3: '服务商分配',
    4: '其他',
    5: '其他',
  };

  /**
   * 资源包状态的枚举值
   */
  const packageStatusEnum: any = {
    1: '生效中',
    2: '未生效',
    3: '已失效',
  };

  const columns: ColumnsType<DataType> = [
    {
      title: '类型',
      key: 'source',
      dataIndex: 'source',
      render: (text: number) => <text>{packageSourceEnum[text]}</text>,
    },
    {
      title: '状态',
      key: 'status',
      dataIndex: 'status',
      render: (text: number) => <text>{packageStatusEnum[text]}</text>,
    },
    {
      title: '资源包ID',
      dataIndex: 'pkgId',
      key: 'pkgId',
    },
    {
      title: '商品SPU ID',
      dataIndex: 'spuId',
      key: 'spuId',
    },
    {
      title: '商品SKU ID',
      dataIndex: 'skuId',
      key: 'skuId',
    },
    {
      title: '总额度',
      dataIndex: 'all',
      key: 'all',
      render: (text) => <text style={{ color: 'blue' }}>{text}</text>,
    },
    {
      title: '已使用额度',
      dataIndex: 'used',
      key: 'used',
      render: (text) => <text style={{ color: 'red' }}>{text}</text>,
    },
    {
      title: '有效期开始时间',
      dataIndex: 'startTime',
      key: 'startTime',
      render: (text) => <span>{moment(text * 1000).format('YYYY-MM-DD HH:mm')}</span>,
    },
    {
      title: '有效期结束时间',
      dataIndex: 'endTime',
      key: 'endTime',
      render: (text) => <span>{moment(text * 1000).format('YYYY-MM-DD HH:mm')}</span>,
    },
  ];
  // ======= 详细资源包使用情况 =======

  return (
    <Modal
      title={`${appInfo?.appName}/手机快速验证用量使用情况`}
      open={chargeVisible}
      maskClosable={true}
      onOk={() => setChargeVisible(false)}
      onCancel={() => setChargeVisible(false)}
      width={1200}
      footer={null}
    >
      <Row gutter={24}>
        <Col span={6}>
          <Statistic title="总额度" valueStyle={{ color: 'blue' }} value={chargeUsage?.all} />
        </Col>
        <Col span={6}>
          <Statistic
            title="已使用额度"
            valueStyle={{ color: 'red' }}
            value={chargeUsage?.effectiveUse}
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="剩余额度"
            valueStyle={{ color: 'green' }}
            value={chargeUsage?.all - chargeUsage?.effectiveUse}
          />
        </Col>
        <Col span={6}>
          <Statistic title="最近三个月的平均用量" value={chargeRecentAverageUsage?.averageData} />
        </Col>
      </Row>
      <Divider orientation="left" orientationMargin={0}>
        详细资源包使用情况({chargeUsage?.detailList?.length || 0})
      </Divider>
      <Table columns={columns} dataSource={chargeUsage?.detailList || []} />
    </Modal>
  );
};
export default AppChargeUsageModal;
